import React from 'react';
import { useConnect } from '@lore/query-connect';
import { project_networkId } from '../../../../utils/query-helpers';

export default function useQuestions(state, network, schoolStart, schoolEnd, extra = {}) {
  return useConnect('question.find', {
    where: {
      eager: {
        $where: {
          // ...project_networkId(network),
          project: {
            $where: {
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });
}
